import React from 'react'
import { strings } from '../../../localization/strings'
import Copy from './copy.js'
import ConfigPanel from './configPanel'

const Component = ({ config, handleEdit }) => {
    if (!config.secret) return null

    return (
        <ConfigPanel
            title={strings.wooCommerceConfigTitle}
            items={[
                {
                    label: strings.wooCommerceConfigSecret,
                    control: (
                        <>
                            <div style={{ fontSize: '80%' }}>
                                {config.secret}
                            </div>
                            <Copy color="inherit" text={config.secret} />
                        </>
                    ),
                },
            ]}
        />
    )
}

export default Component
